export const HOTSPOT_SIZE = 20;

export default {
  HOTSPOT_SIZE,
};
